"use strict";

exports.__esModule = true;
exports.MeasureChartWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _MeasureChartElement = require("./MeasureChartElement");
var _ChartCard = require("../common/ChartCard");
var _MeasureChartFields = require("./MeasureChartFields");
var _MeasureChartThumbnail = require("./MeasureChartThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MeasureChartWidget = exports.MeasureChartWidget = {
  name: "MeasureChart",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MeasureChartWidget.label",
    defaultMessage: "Measure Chart"
  }),
  icon: "label",
  group: _widgetGroups.TIMELINE_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "MeasureChart",
      props: Object.assign({
        width: 256,
        height: 256,
        measureChartSeries: [],
        scatterPlotRadius: 5
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: ["device"],
  suppliesContexts: [],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 3840
    },
    height: {
      "default": 64,
      min: 32,
      max: 2160
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_MeasureChartElement.MeasureChartElement, function (props) {
      var first = (props.measureChartSeries || [])[0];
      return {
        title: first && (first.label || first.name || first.id) || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "MeasureChartWidget.card.title",
          defaultMessage: "Measure"
        })
      };
    }),
    Fields: _MeasureChartFields.MeasureChartFields,
    Thumbnail: _MeasureChartThumbnail.MeasureChartThumbnail
  }
};